<template>
  <span>
    <div
      v-if="schema.attributes.editing && !disabledForAdminOnly"
      class="form-group checkboxes">
      <label
        class="form-checkbox form-inline"
        :key="idx" v-for="(item, idx) in items">
        <input
          v-model="selected[item]"
          ref="checkbox"
          type="checkbox"
          @change="updateValue"
          :autocomplete="schema.autocomplete"
          :class="schema.fieldClasses"
          :disabled="disabled || disabledForAdminOnly || null"
          :id="`${getFieldID(schema)}-${idx}`"
          :nameId="schema.inputName"
          :value="item"
        />
        <i class="form-icon"></i> {{ item }}
      </label>
    </div>
    <template v-else>
      <span v-if="!lodash.isNull(value)" class="response">
        {{ cleanedValue }}
      </span>
      <span
        v-else-if="!schema.attributes.editing"
        style="font-style: italic; color: #555">
        Not available
      </span>
    </template>
    <div
      class="form-input-hint text-error"
      v-if="schema.attributes.editing && disabledForAdminOnly">
      Field is restricted to site administrators.
    </div>
  </span>
</template>

<script>
// This is a lightly modified version of vue-form-generator's select field.
import _ from 'lodash';

import { MixinDataToReactiveData } from 'assets/js/util';

import { abstractField } from 'components/Widgets/FormGenerator';

import FieldCommon from './FieldCommon';

export default {
  name: 'field-q-check-boxes',

  mixins: [abstractField, FieldCommon],

  setup() {
    const afd = MixinDataToReactiveData(abstractField);
    const fcd = MixinDataToReactiveData(FieldCommon);
    return {
      ...afd,
      ...fcd,
    };
  },

  computed: {
    items() {
      return this.schema.values;
    },

    cleanedValue() {
      if (!this.value) return '';
      return this.value.join(', ');
    },
  },

  data() {
    return {
      selected: {},
    };
  },

  mounted() {
    // Setup the default values internally. If a particular value is set,
    // then set it to true, otherwite set it to false. We index by the
    // item name since we cannot store by index (list of options can change)
    // and if two things have the same name, we expect both to be checked.
    _.map(this.items, (item) => {
      this.selected[item] = this.value && this.value.indexOf(item) !== -1;
    });
  },

  methods: {
    updateValue() {
      // Get an array of all selected items.
      // { itemA: true, itemB: false } => [['itemA', true], ['itemB', false]]
      // => [['itemA', true]] => ['itemA']
      this.value = _.map(
        _.filter(_.toPairs(this.selected), (p) => p[1]),
        (item) => item[0],
      );

      // Required to set to null so Required computations work.
      if (this.value.length === 0) this.value = null;
    },
  },
};
</script>

<style lang="scss" scoped>
  .checkboxes {
    .form-group {
      margin-bottom: 0.2em;
    }
  }
</style>
